var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-truck","titulo":"ENTREGAS SGF","subTitulo":"GERENTE"},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Gerentes_Entregas' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }